export default __webpack_public_path__ + "static/media/marauders-map-v4-03-02.5bdada57.jpg";